import { Button, DatePicker, Form, Select, Space } from "antd";
import TextArea from "antd/es/input/TextArea";
import dayjs from "dayjs";
import DateIcon from "../../../assets/icons/DateIcon";
import SelectDropdownLgIcon from "../../../assets/icons/SelectDropdownLgIcon";
import { dateFormat } from "../../../constants/constants";
import { formatDate } from "../../../lib/time";
import { ModalComponentProps } from "../../../types";
import { selectSearchOption, selectStringOption } from "../../../utils/utils";
import SelectImgNameTitle from "../../common/SelectImgNameTitle";
import CustomModal from "../../ui/CustomModal";

export default function LeaveAdjustmentModal({
  handleClose,
  ...rest
}: ModalComponentProps) {
  const [form] = Form.useForm();

  const onFinish = () => {
    // console.log("submit");
  };

  return (
    <CustomModal
      title="Leave Adjustment"
      {...rest}
      handleClose={handleClose}
      width={700}
      footer={null}
    >
      <Form
        className="custom-form"
        layout="vertical"
        requiredMark="optional"
        size="large"
        onFinish={onFinish}
        form={form}
      >
        <div className="grid md:grid-cols-2 gap-x-4">
          <Form.Item
            name="Leave Type"
            label="Leave Type"
            className="mb-4"
            rules={[
              {
                required: true,
                message: "Please select leave type",
              },
            ]}
          >
            <Select
              placeholder="Select"
              size="large"
              allowClear
              showSearch
              filterOption={selectSearchOption}
              options={selectStringOption(["Annual Leave"])}
              suffixIcon={<SelectDropdownLgIcon />}
            />
          </Form.Item>

          <Form.Item
            name="Day Type"
            label="Day Type"
            className="mb-1.5"
            rules={[
              {
                required: true,
                message: "Please select day type",
              },
            ]}
          >
            <Select
              placeholder="Select"
              size="large"
              allowClear
              showSearch
              filterOption={selectSearchOption}
              options={selectStringOption(["Full Day"])}
              suffixIcon={<SelectDropdownLgIcon />}
            />
          </Form.Item>

          <Form.Item
            name="Leave Period"
            label="Leave Period"
            className="mb-4"
            rules={[
              {
                required: true,
                message: "Please select leave period",
              },
            ]}
          >
            <DatePicker.RangePicker
              defaultValue={[
                dayjs(formatDate(), dateFormat),
                dayjs(formatDate(), dateFormat),
              ]}
              format={dateFormat}
              suffixIcon={<DateIcon width={18} height={20} />}
              style={{ width: "100%" }}
              size="large"
            />
          </Form.Item>

          <Form.Item
            name="Total Days"
            label="Total Days"
            className="mb-1.5"
            rules={[
              {
                required: true,
                message: "Please select total days",
              },
            ]}
          >
            <Select
              placeholder="Select"
              size="large"
              allowClear
              showSearch
              filterOption={selectSearchOption}
              options={selectStringOption([
                "1 Day",
                "2 Day",
                "3 Day",
                "4 Day",
                "5 Day",
              ])}
              suffixIcon={<SelectDropdownLgIcon />}
            />
          </Form.Item>
        </div>

        <Form.Item name="Note" label="Note" className="mb-4">
          <TextArea rows={5} placeholder="Enter a description..." />
        </Form.Item>

        <Form.Item
          name="Approver"
          label="Approver"
          className="mb-4"
          rules={[
            {
              required: true,
              message: "Please enter approver",
            },
          ]}
        >
          <SelectImgNameTitle placeholder="Select" data={[]} />
        </Form.Item>

        <Space className="w-full mt-2" size={12}>
          <Button
            className="normal-dark-button modal-button"
            onClick={handleClose}
            size="middle"
          >
            Cancel
          </Button>
          <Button
            className="modal-button"
            type="primary"
            htmlType="submit"
            size="middle"
          >
            Update
          </Button>
        </Space>
      </Form>
    </CustomModal>
  );
}
